import React from 'react';

import './style.scss';

const ActivityAddress = ({ entity }) => {
  const locationName = entity.getIn(['field_location', 0, 'entity', 'name', 0, 'value'], '');
  const addressLine1 = entity.getIn(['field_location', 0, 'entity', 'field_address', 0, 'address_line1'], '');
  const addressLine2 = entity.getIn(['field_location', 0, 'entity', 'field_address', 0, 'address_line2'], '');
  const city = entity.getIn(['field_location', 0, 'entity', 'field_address', 0, 'locality'], '');
  const postalCode = entity.getIn(['field_location', 0, 'entity', 'field_address', 0, 'postal_code'], '');

  if (!locationName || !addressLine1) {
    return;
  }

  return (
    <div className="NodeActivity__location">
      <i className="icon icon-pin2 icon-variant-0" />
      <div>
        <span className="bold">{locationName}</span><br />
        {addressLine1 && <p>{addressLine1}</p>}
        {addressLine2 && <p>{addressLine2}</p>}
        {city && (
          <p>
            {postalCode} {city}
          </p>
        )}
      </div>
    </div>
  );
};

export default ActivityAddress;
